import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import './App.css';

function App() {
  useEffect(() => {
    // SEO: Add structured data for the entire application
    const appData = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Zardoz.ai",
      "description": "Zardoz.ai: Zero-Audit Resilient Defense Over Zero-Knowledge. Enterprise AI security.",
      "url": window.location.origin,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Any",
      "offers": {
        "@type": "Offer",
        "price": "Custom",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      },
      "provider": {
        "@type": "Organization",
        "name": "Zardoz.ai",
        "url": window.location.origin
      }
    };
    
    const scriptId = 'app-structured-data';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(appData);
    
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;